"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var AcdcContext_1 = require("./AcdcContext");
var useAcdcReducer_1 = require("./useAcdcReducer");
var useBlurHandler_1 = require("./useBlurHandler");
function useAcdcInputProps() {
    var ownRef = react_1.useRef(null);
    var _a = AcdcContext_1.useAcdcContext(), dispatch = _a.dispatch, _b = _a.state, value = _b.value, isOpen = _b.isOpen, keyboardHighlightedIndex = _b.keyboardHighlightedIndex;
    var _c = AcdcContext_1.useAcdcElementRegistryContext(), id = _c.id, setInputElement = _c.setInputElement, inputId = _c.inputId, labelId = _c.labelId, popupId = _c.popupId;
    react_1.useEffect(function () {
        setInputElement(ownRef.current);
    }, [setInputElement, ownRef.current]);
    var onKeyDown = react_1.useCallback(function (event) {
        switch (event.key) {
            case 'ArrowDown':
                event.preventDefault();
                dispatch({ type: useAcdcReducer_1.ActionTypes.KeyDownArrowDown });
                break;
            case 'ArrowUp':
                event.preventDefault();
                dispatch({ type: useAcdcReducer_1.ActionTypes.KeyDownArrowUp });
                break;
            case 'Enter':
                dispatch({ type: useAcdcReducer_1.ActionTypes.KeyDownEnter });
                break;
            case 'Escape':
                dispatch({ type: useAcdcReducer_1.ActionTypes.KeyDownEscape });
                break;
            default:
                dispatch({ type: useAcdcReducer_1.ActionTypes.KeyDownUnknown, key: event.key });
        }
    }, [dispatch]);
    var onChange = react_1.useCallback(function (e) { return dispatch({ type: useAcdcReducer_1.ActionTypes.InputChange, value: e.target.value }); }, [dispatch]);
    var onFocus = react_1.useCallback(function () { return dispatch({ type: useAcdcReducer_1.ActionTypes.InputFocus }); }, [dispatch]);
    var onBlur = useBlurHandler_1.useInputBlurHandler();
    var onClick = react_1.useCallback(function () {
        if (!isOpen) {
            dispatch({ type: useAcdcReducer_1.ActionTypes.InputClick });
        }
    }, [dispatch, isOpen]);
    return [{
            value: value,
            onKeyDown: onKeyDown,
            onChange: onChange,
            onFocus: onFocus,
            onBlur: onBlur,
            onClick: onClick,
            'id': inputId,
            'ref': ownRef,
            'role': 'combobox',
            'aria-haspopup': 'listbox',
            'aria-expanded': isOpen,
            'aria-labelledby': labelId,
            'aria-controls': popupId,
            'aria-activedescendant': keyboardHighlightedIndex !== null
                ? id + "-option-" + keyboardHighlightedIndex
                : null,
        }];
}
exports.default = useAcdcInputProps;
